function rgbToRgba(rgb) {
  return "rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + "," + rgb.a + ")";
}

export { rgbToRgba };
